module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"action":"Change e-mail"},"da":{"action":"Skift e-mail"}}')
  delete Component.options._Ctor
}
